<template>
  <v-stepper-content step="1">
    <v-card class="mx-1 mb-12">
      <v-card-title>{{ $t("form.labels.information") }}</v-card-title>
      <v-card-text><p v-html="infoText"></p></v-card-text>

      <v-card-actions>
        <v-row>
          <v-btn
            class="ml-4 mb-3"
            color="primary"
            @click="$emit('onContinue', true)"
            >
            {{ $t("toRegistration") }}
          </v-btn>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-stepper-content>
</template>

<script>
export default {
  computed: {
    infoText() {
      return window.formInfoText || this.$t("form.labels.infoDefault");
    },
  },
};
</script>
